export interface Tier {
  id: string;
  label: string;
  rank: number;
  threshold: number;
}

const TIERS: Tier[] = [
  { id: 'retail', label: 'Retail Degenerate', rank: 1, threshold: 0 },
  { id: 'whale', label: 'Whale', rank: 2, threshold: 100_000 },
  { id: 'tycoon', label: 'Tycoon', rank: 3, threshold: 10_000_000 },
  { id: 'billionaire', label: 'Billionaire', rank: 4, threshold: 1_000_000_000 },
  { id: 'centibillionaire', label: 'Centibillionaire', rank: 5, threshold: 100_000_000_000 },
  { id: 'trillionaire', label: 'Trillionaire', rank: 6, threshold: 1_000_000_000_000 },
  { id: 'god', label: 'God Tier', rank: 7, threshold: 1_000_000_000_000_000 },
];

export function tierForNetWorth(nw: number): Tier {
  let current = TIERS[0]!;
  for (const t of TIERS) {
    if (nw >= t.threshold) current = t;
  }
  return current;
}

export function tierByRank(rank: number): Tier | undefined {
  return TIERS.find((t) => t.rank === rank);
}

export const COINS_BY_RANK = [0, 1, 5, 25, 100, 500, 2500, 10000];
export function coinsForRank(rank: number): number {
  return COINS_BY_RANK[Math.min(rank, COINS_BY_RANK.length - 1)] ?? 0;
}
